declare namespace $ {

	type $mol_link_source__uri_bog_invest_app_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link_source['uri'] >
	>
	type $bog_theme_toggle__theme_auto_bog_invest_app_2 = $mol_type_enforce<
		ReturnType< $bog_invest_app['Theme'] >
		,
		ReturnType< $bog_theme_toggle['theme_auto'] >
	>
	type $bog_theme_auto__theme_light_bog_invest_app_3 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_theme_auto['theme_light'] >
	>
	type $bog_theme_auto__theme_dark_bog_invest_app_4 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_theme_auto['theme_dark'] >
	>
	type $bog_theme_auto__themes_bog_invest_app_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_theme_auto['themes'] >
	>
	type $mol_switch__value_bog_invest_app_6 = $mol_type_enforce<
		ReturnType< $bog_invest_app['screen'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_bog_invest_app_7 = $mol_type_enforce<
		ReturnType< $bog_invest_app['nav_options'] >
		,
		ReturnType< $mol_switch['options'] >
	>
	export class $bog_invest_app extends $mol_page {
		Calc( ): $bog_invest_calc
		Lk( ): $bog_invest_lk
		screen( next?: string ): string
		Sources( ): $mol_link_source
		Status( ): $giper_baza_status
		Theme_toggle( ): $bog_theme_toggle
		Theme( ): $bog_theme_auto
		screen_body( ): readonly(any)[]
		title( ): string
		pages( ): ({ 
			'calc': ReturnType< $bog_invest_app['Calc'] >,
			'lk': ReturnType< $bog_invest_app['Lk'] >,
		}) 
		nav_options( ): ({ 
			'calc': string,
			'lk': string,
		}) 
		Navbar( ): $mol_switch
		tools( ): readonly(any)[]
		head( ): readonly(any)[]
		plugins( ): readonly(any)[]
		body( ): ReturnType< $bog_invest_app['screen_body'] >
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map